module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG5159410fc10ca594826b53eb6bbc51dc.5159410f.png";